module.exports = __webpack_public_path__ + "static/media/rocket.d34e1bf6.svg";